/**
 * Assessment Performance — async thunk for the metrics endpoint.
 *
 *   GET /accounts/{currentAccountUuid}/survey-performance/metrics
 *
 * Backport from refactor/mui-v9-migration. Adapted for legacy
 * client API (`client.get`) and inlined helpers — no entities/lib
 * dependency on this branch. Response shape is identical:
 *   { rows: [...], totals: {...}, generatedAt: string }
 *
 * Period date range strings are ISO-day (`YYYY-MM-DD`).
 *
 * TEMP: This file (and the matching slice) will be deleted once
 * refactor/mui-v9-migration merges back into development — the
 * FSD layout under @entities/assessment-performance owns the
 * canonical thunk + slice on that branch.
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../client';

const buildQueryString = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    search.append(k, Array.isArray(v) ? v.join(',') : v);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
};

export const fetchAssessmentMetrics = createAsyncThunk(
  'assessmentPerformance/fetchMetrics',
  async (
    { accountUuid, periodA, periodB, accountUuids = [] },
    { rejectWithValue },
  ) => {
    try {
      const queryString = buildQueryString({
        periodAStart: periodA?.start,
        periodAEnd: periodA?.end,
        periodBStart: periodB?.start,
        periodBEnd: periodB?.end,
        accountUuids: accountUuids.length ? accountUuids : undefined,
      });
      const response = await client.get(
        `/accounts/${accountUuid}/survey-performance/metrics${queryString}`,
      );
      if (response.ok) {
        // Live QHS responses are wrapped as `{ data: <body>, correlationUUID }`.
        const body = response.data?.data ?? response.data;
        return {
          ok: true,
          data: {
            rows: body?.rows || [],
            totals: body?.totals || null,
            generatedAt: body?.generatedAt || null,
          },
        };
      }
      return rejectWithValue({
        error: { message: response.data?.message || 'Failed to load metrics' },
      });
    } catch (error) {
      return rejectWithValue({
        error: { message: error.message || 'Failed to load metrics' },
      });
    }
  },
);
